// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Audits page — org-centric, fixed-height scroll panels */

.au-page {
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: calc(100vh - 120px);
  min-height: 480px;
  max-height: calc(100vh - 100px);
}

.au-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  flex-shrink: 0;
}

.au-stat {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 12px 14px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.au-stat-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.au-stat-icon--blue { background: #eff6ff; color: #2563eb; }
.au-stat-icon--slate { background: #f1f5f9; color: #64748b; }
.au-stat-icon--green { background: #ecfdf5; color: #059669; }
.au-stat-icon--red { background: #fef2f2; color: #dc2626; }

.au-stat-value {
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.1;
}

.au-stat-label {
  font-size: 13px;
  color: #94a3b8;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.au-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  flex-wrap: wrap;
}

.au-search {
  flex: 1 1;
  min-width: 180px;
  max-width: 320px;
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  background: #fff;
}

.au-select {
  padding: 8px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  background: #fff;
  color: #334155;
}

.au-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #475569;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

.au-btn:hover {
  background: #f8fafc;
}

.au-main {
  display: grid;
  grid-template-columns: 260px 1fr;
  gap: 10px;
  flex: 1 1;
  min-height: 0;
}

.au-panel {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.au-panel-head {
  padding: 10px 12px;
  border-bottom: 1px solid #f1f5f9;
  background: #fafbfc;
  flex-shrink: 0;
}

.au-panel-title {
  font-size: 15px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin: 0;
}

.au-panel-sub {
  font-size: 13px;
  color: #94a3b8;
  margin: 2px 0 0;
}

.au-panel-body {
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
}

.au-org-item,
.au-license-item {
  width: 100%;
  border: none;
  background: transparent;
  text-align: left;
  cursor: pointer;
  padding: 10px 12px;
  border-bottom: 1px solid #f8fafc;
  transition: background 0.12s;
}

.au-org-item:hover,
.au-license-item:hover {
  background: #f8fafc;
}

.au-org-item.active,
.au-license-item.active {
  background: #eff6ff;
  border-left: 3px solid #2563eb;
  padding-left: 9px;
}

.au-org-name {
  display: block;
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
}

.au-org-meta {
  display: block;
  font-size: 13px;
  color: #94a3b8;
  margin-top: 2px;
}

.au-detail-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #94a3b8;
  font-size: 15px;
  padding: 24px;
  text-align: center;
}

.au-detail-header {
  padding: 12px 14px;
  border-bottom: 1px solid #f1f5f9;
  background: #fafbfc;
}

.au-detail-org {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.au-detail-email {
  font-size: 15px;
  color: #64748b;
  margin: 2px 0 0;
}

.au-detail-stats {
  display: flex;
  gap: 12px;
  margin-top: 8px;
  font-size: 13px;
  color: #64748b;
}

.au-detail-stats span strong {
  color: #334155;
}

.au-timeline {
  padding: 8px 0;
}

.au-event {
  display: flex;
  gap: 10px;
  padding: 10px 14px;
  border-bottom: 1px solid #f8fafc;
}

.au-event-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-top: 5px;
  flex-shrink: 0;
}

.au-event-dot--ok { background: #22c55e; }
.au-event-dot--fail { background: #ef4444; }

.au-event-body {
  flex: 1 1;
  min-width: 0;
}

.au-event-top {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.au-event-type {
  font-size: 15px;
  font-weight: 600;
  color: #334155;
}

.au-event-badge {
  font-size: 14px;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 999px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.au-event-badge--login { background: #ecfdf5; color: #047857; }
.au-event-badge--logout { background: #fffbeb; color: #b45309; }
.au-event-badge--license { background: #eff6ff; color: #1d4ed8; }
.au-event-badge--fail { background: #fef2f2; color: #b91c1c; }
.au-event-badge--admin { background: #f5f3ff; color: #6d28d9; }

.au-event-meta {
  font-size: 13px;
  color: #94a3b8;
  margin-top: 3px;
  line-height: 1.4;
}

.au-loading {
  padding: 32px;
  text-align: center;
  color: #94a3b8;
  font-size: 15px;
}

.animate-spin {
  animation: au-spin 0.8s linear infinite;
}

@keyframes au-spin {
  to { transform: rotate(360deg); }
}

@media (max-width: 900px) {
  .au-main {
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
  }

  .au-page {
    height: auto;
    max-height: none;
  }

  .au-panel-body {
    max-height: 240px;
  }

  .au-stats {
    grid-template-columns: repeat(2, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LoginAuditsPage.css"],"names":[],"mappings":"AAAA,0DAA0D;;AAE1D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;;AAE1D;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,SAAO;EACP,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAO;EACP,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,oBAAoB,mBAAmB,EAAE;AACzC,sBAAsB,mBAAmB,EAAE;;AAE3C;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;AAC9D,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;AAC/D,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;AAChE,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;;AAE9D;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qCAAqC;EACvC;AACF","sourcesContent":["/* Audits page — org-centric, fixed-height scroll panels */\n\n.au-page {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  height: calc(100vh - 120px);\n  min-height: 480px;\n  max-height: calc(100vh - 100px);\n}\n\n.au-stats {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.au-stat {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 12px 14px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.au-stat-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.au-stat-icon--blue { background: #eff6ff; color: #2563eb; }\n.au-stat-icon--slate { background: #f1f5f9; color: #64748b; }\n.au-stat-icon--green { background: #ecfdf5; color: #059669; }\n.au-stat-icon--red { background: #fef2f2; color: #dc2626; }\n\n.au-stat-value {\n  font-size: 20px;\n  font-weight: 700;\n  color: #0f172a;\n  line-height: 1.1;\n}\n\n.au-stat-label {\n  font-size: 13px;\n  color: #94a3b8;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.au-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n}\n\n.au-search {\n  flex: 1;\n  min-width: 180px;\n  max-width: 320px;\n  padding: 8px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 15px;\n  background: #fff;\n}\n\n.au-select {\n  padding: 8px 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 15px;\n  background: #fff;\n  color: #334155;\n}\n\n.au-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #475569;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.au-btn:hover {\n  background: #f8fafc;\n}\n\n.au-main {\n  display: grid;\n  grid-template-columns: 260px 1fr;\n  gap: 10px;\n  flex: 1;\n  min-height: 0;\n}\n\n.au-panel {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.au-panel-head {\n  padding: 10px 12px;\n  border-bottom: 1px solid #f1f5f9;\n  background: #fafbfc;\n  flex-shrink: 0;\n}\n\n.au-panel-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  margin: 0;\n}\n\n.au-panel-sub {\n  font-size: 13px;\n  color: #94a3b8;\n  margin: 2px 0 0;\n}\n\n.au-panel-body {\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.au-org-item,\n.au-license-item {\n  width: 100%;\n  border: none;\n  background: transparent;\n  text-align: left;\n  cursor: pointer;\n  padding: 10px 12px;\n  border-bottom: 1px solid #f8fafc;\n  transition: background 0.12s;\n}\n\n.au-org-item:hover,\n.au-license-item:hover {\n  background: #f8fafc;\n}\n\n.au-org-item.active,\n.au-license-item.active {\n  background: #eff6ff;\n  border-left: 3px solid #2563eb;\n  padding-left: 9px;\n}\n\n.au-org-name {\n  display: block;\n  font-size: 15px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.au-org-meta {\n  display: block;\n  font-size: 13px;\n  color: #94a3b8;\n  margin-top: 2px;\n}\n\n.au-detail-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: #94a3b8;\n  font-size: 15px;\n  padding: 24px;\n  text-align: center;\n}\n\n.au-detail-header {\n  padding: 12px 14px;\n  border-bottom: 1px solid #f1f5f9;\n  background: #fafbfc;\n}\n\n.au-detail-org {\n  font-size: 15px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n\n.au-detail-email {\n  font-size: 15px;\n  color: #64748b;\n  margin: 2px 0 0;\n}\n\n.au-detail-stats {\n  display: flex;\n  gap: 12px;\n  margin-top: 8px;\n  font-size: 13px;\n  color: #64748b;\n}\n\n.au-detail-stats span strong {\n  color: #334155;\n}\n\n.au-timeline {\n  padding: 8px 0;\n}\n\n.au-event {\n  display: flex;\n  gap: 10px;\n  padding: 10px 14px;\n  border-bottom: 1px solid #f8fafc;\n}\n\n.au-event-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  margin-top: 5px;\n  flex-shrink: 0;\n}\n\n.au-event-dot--ok { background: #22c55e; }\n.au-event-dot--fail { background: #ef4444; }\n\n.au-event-body {\n  flex: 1;\n  min-width: 0;\n}\n\n.au-event-top {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.au-event-type {\n  font-size: 15px;\n  font-weight: 600;\n  color: #334155;\n}\n\n.au-event-badge {\n  font-size: 14px;\n  font-weight: 600;\n  padding: 2px 7px;\n  border-radius: 999px;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.au-event-badge--login { background: #ecfdf5; color: #047857; }\n.au-event-badge--logout { background: #fffbeb; color: #b45309; }\n.au-event-badge--license { background: #eff6ff; color: #1d4ed8; }\n.au-event-badge--fail { background: #fef2f2; color: #b91c1c; }\n.au-event-badge--admin { background: #f5f3ff; color: #6d28d9; }\n\n.au-event-meta {\n  font-size: 13px;\n  color: #94a3b8;\n  margin-top: 3px;\n  line-height: 1.4;\n}\n\n.au-loading {\n  padding: 32px;\n  text-align: center;\n  color: #94a3b8;\n  font-size: 15px;\n}\n\n.animate-spin {\n  animation: au-spin 0.8s linear infinite;\n}\n\n@keyframes au-spin {\n  to { transform: rotate(360deg); }\n}\n\n@media (max-width: 900px) {\n  .au-main {\n    grid-template-columns: 1fr;\n    grid-template-rows: auto 1fr;\n  }\n\n  .au-page {\n    height: auto;\n    max-height: none;\n  }\n\n  .au-panel-body {\n    max-height: 240px;\n  }\n\n  .au-stats {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
